import {UICoinsController} from '../../../shared/scripts/ui_coins/UICoinsController'
import {audioManager, AudioType} from '../../../shared/scripts/Sound'
import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums'
import {UIMSceneController} from '../ui_html/UIMSceneController'

export class UIMCoinsController extends UICoinsController {
    private readonly sceneController: UIMSceneController

    constructor(sceneController: UIMSceneController) {
        super()
        this.sceneController = sceneController
    }

    protected initCoinClick() {
        setElementOnClick(this.headerCoinsContainer, () => {
            audioManager.play(AudioType.Click)
            this.sendCoinClickAnalytic()
            this.sceneController.loadScene(UIMSceneEnum.Store)
        })
    }
}
